var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMegabytesIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 46 26",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeWidth: 3,
    d: "M2 2h42v22H2z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Raleway-ExtraBold, Raleway",
    fontSize: 20,
    fontWeight: 600,
    fill: "currentColor",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 6.06,
    y: 19
  }, "MB")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegabytesIcon);
export default __webpack_public_path__ + "static/media/megabytes-icon.0743a083f0865e54b2b6dab843ef8ffa.svg";
export { ForwardRef as ReactComponent };